import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrderOrganisationSelectComponent } from '../order-organisation-select/order-organisation-select.component';

import { Router } from '@angular/router';

@Component({
  selector: 'app-order-organisation-form',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    ModalHeaderComponent
  ],
  templateUrl: './order-organisation-form.component.html',
  styleUrl: './order-organisation-form.component.scss'
})
export class OrderOrganisationFormComponent implements OnInit {
  private modalService = inject(NgbModal);

  @Input() reload: boolean = false;
  @Input() item: any = {};  

  modalTitle: string = 'Bestelling aanmaken';
  modalStyle: boolean = false;
  formErrors: any = {};

  errorMessage: string = '';
  loading: boolean = false;

  periods: any;

  constructor(private apiService: ApiService, private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void {
    this.getPeriods();
  }

  getPeriods() {
    this.loading = true;
    this.apiService.get('/office/periods').then((response: any) => {
      this.periods = response.data;
      this.loading = false;
    }).catch(error => {
      this.loading = false;
      this.errorMessage = 'Error fetching periods';
    });
  }

  selectOrganisation() {
    let self = this;
    const modalRef = this.modalService.open(OrderOrganisationSelectComponent, { size: 'xl' });
    modalRef.componentInstance.modalStyle = true;
    modalRef.componentInstance.setItem(this.item);
    modalRef.result.then((organisation) => {
      self.item.organisation_name = organisation['name'];
      self.item.organisation_type = organisation['type'];
      self.item.organisation_address = organisation['address'];
      self.item.organisation_postal_code = organisation['postal_code'];
      self.item.organisation_city = organisation['city'];
      self.item.organisation_location = organisation['location'];
      self.item.organisation_country = 'Nederland';
      self.item.email = organisation['contact_email'];
      self.item.invoice_email = organisation['contact_email'];
      self.item.organisation_id = organisation['id'];

      self.item.invoice_name = organisation['name'];
      self.item.invoice_email = organisation['invoice_email'];
      self.item.invoice_address = organisation['address'];
      self.item.invoice_postal_code = organisation['postal_code'];
      self.item.invoice_city = organisation['city'];
      self.item.invoice_country = 'Nederland';

      self.item.organisation_department_number = organisation['department_number']
    });
  }

  save() {
    this.loading = true;
    this.apiService.patch('/office/orders/' + this.item.id, this.item)
    .then(() => {
      this.loading = false;
      this.activeModal.close(true);
    })
    .catch(() => {
      this.loading = false;
      this.errorMessage = 'Fout bij het opslaan.';
    });
    return;
  }
}
